import { useUrlGenerator } from '@folklore/routes';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useLocation } from 'wouter';

import { useMenus } from '../../../contexts/SiteContext';
import { useSetUser, useUser } from '../../../contexts/UserContext';
import AccountForm from '../../forms/Account';
import PageMeta from '../../partials/PageMeta';
import Sidebar from '../../partials/Sidebar';

import styles from '../../../../styles/pages/pro.module.css';

const propTypes = { page: PropTypes.shape({ id: PropTypes.string }) };

function AccountPage({ page = null }) {
    const { pro } = useMenus();
    const route = useUrlGenerator();
    const [, setLocation] = useLocation();
    const setUser = useSetUser();
    const user = useUser();
    const { title = null, action = null, fields = null } = page || {};

    const onComplete = useCallback(
        (data) => {
            if (data !== null) {
                setUser(data);
            }
            setLocation(`${route('pro.home')}?saved=1`);
        },
        [route, setLocation],
    );

    return (
        <div className={styles.container}>
            <PageMeta page={page} />
            <Sidebar className={styles.sidebar} menu={pro} title={title}>
                {user !== null ? (
                    <AccountForm
                        className={styles.form}
                        action={action}
                        fields={fields}
                        user={user}
                        onComplete={onComplete}
                    />
                ) : null}
            </Sidebar>
        </div>
    );
}

AccountPage.propTypes = propTypes;

export default AccountPage;
